import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import socketService from "../services/socketService";
import { useParams } from "react-router-dom";
import { kitchenHandler, authHandler } from "../redux/handlers";
export function useKitchenSocket() {
  const navigate = useNavigate();
  const { businessSlug } = useParams();
  const kitchenIdRef = useRef();
  const dispatch = useDispatch();

  const connect = useCallback(
    async (kitchenID) => {
      if (!kitchenID) return;
      kitchenIdRef.current = kitchenID;
      socketService.connect();

      socketService.setKitchenChannel(kitchenID);
      console.log("เริ่มต้นการตรวจสอบ Kitchen จาก server : ", kitchenID);
      const updateFromKitchenChannel = socketService.registerKitchenHandler(async (msg) => {
        console.log(msg);
        if (msg !== "logout") {
          await dispatch(kitchenHandler.handleSocketResponse(msg, false));
        } else {
          console.log("ได้รับคำสั่ง logout จาก Kitchen server");
          localStorage.removeItem("branchPOSId");
          localStorage.removeItem("email");
          localStorage.removeItem("branchId");
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          localStorage.removeItem("branchKitchenId");
          socketService.disconnect();
          await dispatch(authHandler.logout(businessSlug));
          await dispatch(kitchenHandler.logoutKitchen(businessSlug, Number(kitchenIdRef.current)));
          navigate(`/${businessSlug}/login`, { replace: true });
        }
      });
      return updateFromKitchenChannel;
    },
    [dispatch, navigate, businessSlug]
  );

  const disconnect = useCallback(() => {
    if (kitchenIdRef.current) {
      console.log("Disconnecting from kitchen:", kitchenIdRef.current);
      kitchenIdRef.current = null;
      console.log("ได้รับคำสั่ง logout จาก Kitchen server");
      localStorage.removeItem("branchPOSId");
      localStorage.removeItem("email");
      localStorage.removeItem("branchId");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("branchKitchenId");
      socketService.disconnect();
      navigate(`/${businessSlug}/login`, { replace: true });
    }
  }, [navigate, businessSlug]);
  return { connect, disconnect };
}
